import { normalizeDatoloebenrValue } from "src/modules/ANNModule/ANNServitutDocumentAnnotations";
import { AnnotationType, type ANNAnnotationRecord } from "src/modules/ANNModule/ANNTypes";

/** Marker on a Notat so Ignore persists without inventing a PDF Document. */
export const SERVITUT_IGNORE_NOTE_COMMENT = "servitut-ignore";

export function isServitutIgnoreNote(item: ANNAnnotationRecord): boolean {
   return item.type === AnnotationType.Note
      && (item.note?.comment || "").trim() === SERVITUT_IGNORE_NOTE_COMMENT;
}

export function findIgnoreNotes(records: ANNAnnotationRecord[], datoloebenr?: string): ANNAnnotationRecord[] {
   const target = normalizeDatoloebenrValue(datoloebenr);
   return records.filter((item) => {
      if (!isServitutIgnoreNote(item)) {
         return false;
      }
      if (target && normalizeDatoloebenrValue(item.datoloebenr) !== target) {
         return false;
      }
      return true;
   });
}

export function findIgnoreNote(records: ANNAnnotationRecord[], datoloebenr?: string): ANNAnnotationRecord | undefined {
   return findIgnoreNotes(records, datoloebenr)[0];
}
